<script setup>
import { useGlobalStore } from '@stores/global'
import { format } from '@formkit/tempo'
import RegisteredEventCardTag from '@components/global/RegisteredEventCardTag.vue'
import Button from '@components/forms/Button.vue'

const global = useGlobalStore()

const props = defineProps({
	event: {
		type: Object,
		required: true,
	},
})
</script>

<template>
	<div class="relative flex flex-col overflow-hidden rounded-md border-r-2 bg-logi-grey-500" :style="`border-color: ${event.accent_hex ?? '#00AEEF'};`">
		<div class="absolute -left-24 top-3 z-20 flex w-80 -rotate-20 items-center justify-center gap-2 bg-logi-blue-500/40 py-1.5 text-sm uppercase text-white backdrop-blur-xs" :style="event.accent_hex ? `background: ${event.accent_hex + '66'};` : null" v-if="event.completed">
			<i class="far fa-check" />
			<div class="mt-0.5">Completed</div>
		</div>
		<div class="absolute right-0 top-0 z-0 h-full w-14 opacity-[0.07]" :style="`background: linear-gradient(to left, ${event.accent_hex ?? '#00AEEF'}, transparent);`"></div>
		<div class="flex flex-col gap-0.5 md:flex-row">
			<img :src="event.poster" :alt="event.name" :class="['object-cover', event.completed ? 'md:size-36' : 'md:size-48']" />
			<div class="flex w-full flex-col justify-center gap-4 p-3">
				<div class="text-sm text-logi-blue-500" v-if="event.game">{{ event.game.name }}</div>
				<h6 class="grow">{{ event.name }}</h6>
				<div class="flex flex-col gap-2 sm:flex-row">
					<RegisteredEventCardTag icon="fa-regular fa-calendar-days">{{ format(event.start_at, 'MMM D, YYYY') }} - {{ format(event.finish_at, 'MMM D, YYYY') }}</RegisteredEventCardTag>
					<RegisteredEventCardTag :icon="event.prize_pool_icon ? event.prize_pool_icon : 'fa-regular fa-sack-dollar'" v-if="event.prize_formatted">{{ event.prize_formatted }}</RegisteredEventCardTag>
					<RegisteredEventCardTag class="xl:max-2xl:hidden" :icon="event.genre.icon">{{ event.genre.name }}</RegisteredEventCardTag>
				</div>
				<Button class="solid secondary thin full" icon="far fa-pencil" v-if="!event.completed && event.can_edit" @click="global.setModal(['Edit', props.event])">Edit Details</Button>
			</div>
		</div>
	</div>
</template>
